var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cmp-banner-wrap",class:{'mobile': _vm._isMobile}},[_c('div',{staticClass:"cmp-banner"},[(!_vm._isMobile)?_c('img',{attrs:{"src":_vm.bannerObj[_vm.bannerType],"alt":""}}):_c('img',{attrs:{"src":_vm.bannerObjH5[_vm.bannerType],"alt":""}})]),(!_vm.$route.meta.hideBread)?_c('cmpBread'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }